import React from 'react';

const PrintButton = ({ onPrint }) => {
  return (
    <button
      onClick={onPrint}
      className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-semibold"
    >
      Imprimer la réservation
    </button>
  );
};

export default PrintButton;